import type { ListLandIqDataRunsResponse } from '@immo/api-contract';
import type { NetworkError } from '@/lib/errors/network-error';
import { isLandIqPageErrorCode, type LandIqPageErrorCode } from '@/components/landiq/landiq-error-state';

export const BOARD_POLL_INTERVAL_MS = 25_000;

export type BoardPoll =
  | { status: 'loading' }
  | { status: 'crashed'; network?: NetworkError }
  | { status: 'failed'; code: LandIqPageErrorCode }
  | { status: 'loaded'; board: ListLandIqDataRunsResponse; failure: string | undefined | null };

export type BoardPollAction =
  | { type: 'answered'; board: ListLandIqDataRunsResponse }
  | { type: 'failed'; code: string | undefined; network?: NetworkError };

export const INITIAL_BOARD_POLL: BoardPoll = { status: 'loading' };

/** A failed re-read keeps the last board and sets `failure` (`undefined`: an unknown failure); an answer clears it. */
export function boardPollReducer(state: BoardPoll, action: BoardPollAction): BoardPoll {
  if (action.type === 'answered') return { status: 'loaded', board: action.board, failure: null };

  if (state.status === 'loaded') return { ...state, failure: action.code };

  return isLandIqPageErrorCode(action.code)
    ? { status: 'failed', code: action.code }
    : { status: 'crashed', ...(action.network !== undefined ? { network: action.network } : {}) };
}
